/**
红包
**/
<template>
  <div style="width: 1200px; margin: 30px auto">
    <div class="orderSuccess">
      <el-row>
        <el-col :span="3"><i class="el-icon-check orderSuccess_icon"></i></el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="24" class="orderSuccess_tip">
              <span class="orderSuccess_text">订单提交成功！去付款咯～</span>
              <span>应付总额：<i class="orderSuccess_price">{{
                  account || 0
                }}</i></span>
            </el-col>
            <el-col :span="24">
              <el-collapse>
                <el-collapse-item name="1">
                  <template slot="title">
                    <p style="font-size: 14px; font-weight: normal">
                      签收须知：请您与快递一起当面拆箱验
                    </p>
                    <i class="order_detail"><span style="font-size: 14px; font-weight: normal">订单详情</span></i>
                  </template>
                  <div v-for="(item, index) in orderGoodsInfo" :key="index">
                    <div style="margin-bottom: 15px">
                      <span class="text_width">订单号：</span>
                      <span class="text_bgcolor">{{ item.orderNumber }}</span>
                    </div>
                    <!-- 这个地址需要后期转换,暂时这样写 -->
                    <!-- <span>{{item.nameArr}}---------1</span> -->
                    <div style="margin-bottom: 15px">
                      <span class="text_width">收货信息：</span>
                      <span class="text_bgcolor">
                        {{ item.recipient }} &nbsp;
                        {{ item.phoneNumber }} &nbsp; {{ item.areaName }} &nbsp;
                        {{ item.address }} &nbsp;
                        {{ item.shipAddress || '' }}
                      </span>
                    </div>
                    <div style="margin-bottom: 15px">
                      <span class="text_width">商品名称：</span>
                      <span class="text_bgcolor">{{ item.title }}</span>
                      <span v-for="item1 in item.nameArr" :key="item1">
                        {{ item1 }}
                      </span>
                    </div>
                    <!-- <div style="margin-bottom: 15px;"><span class="text_width">配送时间：</span> <span class="text_bgcolor"></span></div>
                                            <div style="margin-bottom: 15px;"><span class="text_width">发票信息：</span> <span class="text_bgcolor"></span></div> -->
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-col>
            <!-- 这个地址需要后期转换,后期开放 -->
            <!-- <el-col :span="24" class="address_info">
                                <span>收货信息: </span>
                                <span> qaz  131***6543    重庆市  重庆市   万州区  qaz</span>
                            </el-col> -->
          </el-row>
        </el-col>
      </el-row>
      <div class="payMethods">
        <!-- 这个,后期开放 -->
        <div class="payMethods_title">选择以下支付方式付款</div>
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="demo-ruleForm" style="border-bottom:none;">
          <el-form-item>
            <el-collapse>
              <el-collapse-item title="站内支付 余额" name="1"
                                style="font-size: 20px; font-weight:600;border-bottom: none;">
                <!-- <p style="font-weight: 600">站内支付 余额</p> -->
                <div class="checked_free">
                  <el-checkbox v-model="checked" @change="changeCheck()">使用预存款支付（可用余额：￥{{
                      getUserPays.userMoney
                    }}）
                  </el-checkbox>
                  <!-- <span>可用余额不足</span> -->
                  <el-form-item v-show="checked" label="输入支付密码 :" prop="pass" style="width: 40%; margin: 20px 0">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                  </el-form-item>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <el-form-item>
            <el-collapse style="margin-top: -25px;">
              <el-collapse-item title="选择在线支付" name="2" style="font-size: 20px;font-weight: 600;">
                <div style="
                    display: flex;
                    justify-content: left;
                    align-items: center;

                  ">
                  <el-radio fill="#ff8100" v-model="ruleForm.radio" label="1" @change="changeCheckRadio()">
                    <el-image
                        class="payMethods_img" :src="require('@/assets/img/alipay.png')">
                    </el-image>
                  </el-radio>
                  <el-radio v-model="ruleForm.radio" label="2" @change="changeCheckRadio()">
                    <el-image
                        class="payMethods_img" :src="require('@/assets/img/wx_native.png')"></el-image>
                  </el-radio>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <!-- 网银支付 -->
          <el-form-item>
            <el-collapse @change="changeCollapse">
              <el-collapse-item title="网银支付" name="3" style="margin-top: -20px;">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="储蓄卡" name="1">
                    <div style="display: flex" v-if="activeName == '1'">
                      <el-row>
                        <el-col :span="4" style="width: auto">
                          <el-radio-group class="radios_outerbox" v-model="modeKey" v-for="(item, index) in navList"
                                          :key="index">
                            <div class="currencyPayment">
                              <div>
                                <el-radio :label="item.id" @change="changeBack(item, index)">
                                  <div style="
                                      display: flex;
                                      justify-content: space-around;
                                      align-items: center;
                                    ">
                                    <div>
                                      <el-image class="currencyPayment_img" :src="`${item.img}`" style="display: block">
                                        <div slot="error" class="image-slot">
                                          <i class="el-icon-picture-outline"></i>
                                        </div>
                                      </el-image>
                                    </div>
                                    <div class="currencyPayment_span">
                                      <span>{{ item.bank }}</span>
                                    </div>
                                  </div>
                                </el-radio>
                              </div>
                            </div>
                          </el-radio-group>
                        </el-col>
                      </el-row>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="信用卡" name="2">
                    <div style="display: flex">
                      <el-row>
                        <el-col :span="4" style="width: auto">
                          <el-radio-group class="radios_outerbox" v-model="modeKey" v-for="(item, index) in navList"
                                          :key="index">
                            <div class="currencyPayment">
                              <div>
                                <el-radio :label="item.id" @change="changeBack(item, index)">
                                  <div style="
                                      display: flex;
                                      justify-content: center;
                                      align-items: center;
                                    ">
                                    <div>
                                      <el-image class="currencyPayment_img" :src="`${item.img}`"
                                                style="display: block"></el-image>
                                    </div>
                                    <div class="currencyPayment_span">
                                      <span>{{ item.bank }}</span>
                                    </div>
                                  </div>
                                </el-radio>
                              </div>
                            </div>
                          </el-radio-group>
                        </el-col>
                      </el-row>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <!-- 上传支付凭证 -->
          <!-- <el-form-item v-if="$route.query.buyNow != 1">
            <el-collapse>
              <el-collapse-item
                title="选择上传支付凭证"
                name="3"
                style="font-size: 20px; font-weight: 600"
              >
                <el-checkbox
                  v-model="paychecked"
                  @change="changePayCheck()"
                  style="display: block; margin-top: 20px"
                  >支付凭证</el-checkbox
                >
                <el-upload
                  v-if="paychecked"
                  name="files"
                  class="avatar-uploader payParper"
                  :action="`${$baseUrl}/center/custom/xunyou/api/common/upload`"
                  :show-file-list="false"
                  :on-success="handleAvatarIDSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  < <div> -->
          <!-- <img
                    v-if="ruleForm.IDImg"
                    :src="ruleForm.IDImg"
                    class="avatar"
                  />
                  <div v-else class="uploadIcon">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <p>上传凭证</p>
                  </div>
                  < </div> -->
          <!-- </el-upload>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>   -->
          <!-- <el-form-item v-if="Membership">
            <el-collapse>
              <el-collapse-item
                title="添加会员凭证信息"
                name="3"
                style="font-size: 20px; font-weight: 600"
              >
                <el-form
                  :model="ruleadd"
                  label-width="80px"
                  :rules="ruleadds"
                  ref="rulesadd"
                >
                  <el-form-item
                    prop="appid"
                    label="唯一标识"
                    style="margin-bottom: 10px"
                  >
                    <el-input
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                      v-model="ruleadd.appid"
                      placeholder="请输入平台方分配给用户的唯一标识"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="支付账号" prop="payaccount">
                    <el-input
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                      v-model="ruleadd.payaccount"
                      placeholder="请输入支付账号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="onhandleAdd"
                      style="margin-top: 20px"
                      >添加</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-collapse-item>
            </el-collapse>
          </el-form-item> -->
          <!-- 快捷通 支付 开始-->
          <el-form-item v-if="kjtEnableObj.enable && kjtEnableObj.merchant">
            <el-collapse accordion v-model="openfastPay">
              <el-collapse-item title="选择快捷通支付" name="1">
                <template slot="title">
                  <el-checkbox v-model="fastChecked" @change="changeFastCheck()"><span
                      style="font-size: 14px">选择快捷通支付</span></el-checkbox>
                </template>
                <div>
                  <el-menu :default-active="navList[0].navId" class="el-menu-demo" mode="horizontal"
                           @select="handleSelect">
                    <template v-for="(item, index) in navList">
                      <el-menu-item :index="item.navId" :key="index" router="true">
                        <i>
                          {{ item.name }}
                        </i>
                      </el-menu-item>
                    </template>
                  </el-menu>
                  <el-radio-group v-model="modeKey" v-for="(item, index) in bankLists[index]" :key="index">
                    <el-radio style="margin-top: 20px; margin-left: 20px" :label="item.radio"
                              @change="changeBack(item, index)">
                      {{ item.bank }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <div class="fastPay" style="
                    display: flex;
                    justify-content: space-between;
                    margin-top: 30px;
                  ">
                  <div style="line-height: 60px; color: #ff6700">
                    支付金额：￥{{ account || 0 }}
                  </div>
                  <el-button size="mini" @click="wangYing" type="primary" class="buttonBgd">网银支付</el-button>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <!-- 快捷通 支付 结束-->

          <!-- 扫码 支付 结束-->
          <!-- <view>{{kjtEnableObj.H5}}==={{kjtEnableObj.merchant}}====={{kjtEnableObj.H5&&kjtEnableObj.merchant}}</view> -->
          <el-form-item v-if="
              kjtEnableObj.enable && kjtEnableObj.H5 && kjtEnableObj.merchant
            ">
            <el-collapse accordion v-model="opencodePay">
              <el-collapse-item title="扫码支付" name="1">
                <template slot="title">
                  <el-checkbox v-model="codeChecked" @change="changecodeCheck()"><span
                      style="font-size: 14px">扫码支付</span></el-checkbox>
                </template>
                <div style="text-align: center">
                  <p style="font-size: 18px; margin-bottom: 8px">支付宝/微信</p>
                  <div>
                    <div style="display: inline-block" id="qrcode" ref="qrcode"></div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <!-- 如果是快捷通 就不展示 -->
          <el-form-item v-if="!openfastPay && !opencodePay">
            <div>支付金额：￥{{ account || 0 }}</div>
            <el-button type="primary" @click="orderNows" class="buttonBgd">确定支付</el-button>
            <!-- 后续打开 -->
            <!-- <el-button
              style="margin-left: 20px"
              type="primary"
              @click="orderNowsmix"
              class="buttonBgd"
              >混合支付</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <!-- 付款后的的弹框 -->
      <el-dialog :visible.sync="dialogVisible" width="30%" center class="dialogBox">
        <div class="textCenter">付款成功, 继续查看订单详情！</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="$router.push('/myOrderDetail')" class="buttonBgd">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <el-dialog :visible.sync="dialogVisibles" width="30%" center class="dialogBox">
      <div class="textCenter" v-html="payPage"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$router.push('/myOrderDetail')" class="buttonBgd">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 点击混合支付的弹出框 -->
    <el-dialog title="组合方式" :visible.sync="centerDialogVisible" :close-on-click-modal="false" width="30%"
               class="mixdialog" center>
      <div>当前可用余额：￥{{ getUserPays.userMoney }}</div>
      <el-input :placeholder="`请输入余额支付的金额，金额不能超过${balanceRatioPrice.toFixed(
          2
        )}`" v-model="balencePay" autocomplete.native="off"></el-input>
      <div style="margin-top: 20px">请输入支付密码</div>
      <el-input type="password" v-model="ruleForm.pass" placeholder="请输入支付密码"
                autocomplete.native="off"></el-input>
      <!-- 支付宝支付和微信支付 -->
      <div class="mixPayed">
        <el-radio v-model="ruleForm.radio" label="3" @change="changeCheckRadio()">
          <el-image class="payMethods_img"
                    :src="require('@/assets/img/alipay.png')"></el-image>
        </el-radio>
        <el-radio v-model="ruleForm.radio" label="4" @change="changeCheckRadio()">
          <el-image class="payMethods_img"
                    :src="require('@/assets/img/wx_native.png')"></el-image>
        </el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="mixPay" class="buttonBgd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import {
  alipay,
  balancePay,
  balancePayMax,
  showorderList,
  getUserPay,
  getSpecificationselect,
  alipayPc,
  alipayPcWX,
  getBalancePayProportion,
  checkPay,
  getZtPay,
  getZtAlipayPcPay,
  paycodeStatus,
  kjtEnable,
  kjtbankList,
  offlinePay,
  bankList,
  getwy,
  voucherlist,
  voucheradd,
} from "@/api/xunyou";

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "" && this.checked == true) {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    return {
      activeName: "1",
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {
        mallUser: {},
      },
      orderGoodsInfo: JSON.parse(sessionStorage.getItem("orderGoodsInfo")) || [],
      account: 0,
      payPage: "",
      checked: true,
      paychecked: false, //支付凭证
      centerDialogVisible: false,
      dialogVisible: false,
      dialogVisibles: false,
      balencePay: "",
      ruleForm: {
        pass: "",
        radio: "",
        IDImg: "",
      },
      rules: {
        pass: [{
          validator: validatePass,
          trigger: "blur"
        }],
      },
      ruleadd: {
        appid: "",
        payaccount: "",
      },
      ruleadds: {
        appid: [{
          required: true,
          message: "请输入平台方分配给用户的唯一标识",
          trigger: "blur",
        },],
        payaccount: [{
          required: true,
          message: "请输入支付账号",
          trigger: "blur"
        },],
      },
      wxAlipay: false,
      // 左侧用户金额
      getUserPays: {},

      balanceRatio: 0, //余额支付比例
      balanceRatioPrice: 0, //余额支付最高额度

      // 快捷通支付
      kjtEnableObj: {},
      codeChecked: false,
      opencodePay: "", //打开二维码折叠面板
      // fastPay:false, //是否是快捷通
      fastChecked: false, //是否是快捷通
      openfastPay: "", //打开银行折叠面板
      zfbAlipay: false,
      activeIndex: "1",
      modeKey: "",
      bankLists: [],
      Membership: true, //判断是否要添加会员凭证

      index: 0,
      payProductCode: 1,
      bankaccounttype: 1,
      midArr: [],
      cidArr: [],
      bankCode: "",
      navLists: [],
      navList: [{
        name: "信用卡",
        bankList: [{
          bank: "工商银行",
          bankCode: "ICBC",
          radio: 1,
        },
          {
            bank: "农业银行",
            bankCode: "ABC",
            radio: 2,
          },
          {
            bank: "中国银行",
            bankCode: "BOC",
            radio: 3,
          },
          {
            bank: "建设银行",
            bankCode: "CCB",
            radio: 4,
          },

          {
            bank: "广发银行",
            bankCode: "GDB",
            radio: 5,
          },
          {
            bank: "浦发银行",
            bankCode: "SPDB",
            radio: 6,
          },
          {
            bank: "光大银行",
            bankCode: "CEB",
            radio: 7,
          },
          {
            bank: "上海银行",
            bankCode: "BOS",
            radio: 8,
          },
          {
            bank: "浙商银行",
            bankCode: "CZB",
            radio: 9,
          },
          {
            bank: "招商银行",
            bankCode: "CMB",
            radio: 10,
          },
          {
            bank: "邮储银行",
            bankCode: "PSBC",
            radio: 11,
          },
          {
            bank: "平安银行",
            bankCode: "SZPAB",
            radio: 12,
          },
          {
            bank: "宁波银行",
            bankCode: "NBCB",
            radio: 13,
          },
          {
            bank: "中信银行",
            bankCode: "CITIC",
            radio: 14,
          },
          {
            bank: "华夏银行",
            bankCode: "HXB",
            radio: 15,
          },
        ],
        navId: "0",
      },
        {
          name: "储蓄卡",
          bankList: [{
            bank: "工商银行",
            bankCode: "ICBC",
            radio: 1,
          },
            {
              bank: "农业银行",
              bankCode: "ABC",
              radio: 2,
            },
            {
              bank: "中国银行",
              bankCode: "BOC",
              radio: 3,
            },
            {
              bank: "建设银行",
              bankCode: "CCB",
              radio: 4,
            },

            {
              bank: "广发银行",
              bankCode: "GDB",
              radio: 5,
            },
            {
              bank: "浦发银行",
              bankCode: "SPDB",
              radio: 6,
            },
            {
              bank: "光大银行",
              bankCode: "CEB",
              radio: 7,
            },
            {
              bank: "上海银行",
              bankCode: "BOS",
              radio: 8,
            },
            {
              bank: "浙商银行",
              bankCode: "CZB",
              radio: 9,
            },
            {
              bank: "招商银行",
              bankCode: "CMB",
              radio: 10,
            },
            {
              bank: "邮储银行",
              bankCode: "PSBC",
              radio: 11,
            },
            {
              bank: "平安银行",
              bankCode: "SZPAB",
              radio: 12,
            },
            {
              bank: "宁波银行",
              bankCode: "NBCB",
              radio: 13,
            },
            {
              bank: "中信银行",
              bankCode: "CITIC",
              radio: 14,
            },
            {
              bank: "华夏银行",
              bankCode: "HXB",
              radio: 15,
            },
          ],
          navId: "1",
        },
        // {
        //   name: "B2B信用卡",
        //   bankList: [
        //     {
        //       bank: "农业银行",
        //       bankCode: "ABC",
        //       radio: 1,
        //     },
        //     {
        //       bank: "工商银行",
        //       bankCode: "ICBC",
        //       radio: 2,
        //     },
        //     {
        //       bank: "建设银行",
        //       bankCode: "CCB",
        //       radio: 3,
        //     },
        //     {
        //       bank: "交通银行",
        //       bankCode: "BCM",
        //       radio: 4,
        //     },
        //     {
        //       bank: "浦发银行",
        //       bankCode: "CIB",
        //       radio: 5,
        //     },
        //     {
        //       bank: "邮储银行",
        //       bankCode: "PSBC",
        //       radio: 6,
        //     },
        //     {
        //       bank: "中国银行",
        //       bankCode: "BOC",
        //       radio: 7,
        //     },
        //     {
        //       bank: "中信银行",
        //       bankCode: "CICC",
        //       radio: 8,
        //     },
        //     {
        //       bank: "平安银行",
        //       bankCode: "SZPAB",
        //       radio: 9,
        //     },
        //     {
        //       bank: "光大银行",
        //       bankCode: "CEB",
        //       radio: 10,
        //     },
        //     {
        //       bank: "华夏银行",
        //       bankCode: "HXB",
        //       radio: 11,
        //     },
        //     {
        //       bank: "兴业银行",
        //       bankCode: "CIB",
        //       radio: 12,
        //     },
        //     {
        //       bank: "民生银行",
        //       bankCode: "CMBC",
        //       radio: 13,
        //     },
        //     {
        //       bank: "北京银行",
        //       bankCode: "BCCB",
        //       radio: 14,
        //     },
        //     {
        //       bank: "上海银行",
        //       bankCode: "BOS",
        //       radio: 15,
        //     },
        //   ],
        //   navId: "2",
        // },
      ],
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getkjtbankList();
    //获取银行编码
    // this.getbanklist();
    // this.MembershipCredentials();
  },
  mounted() {
    this.getbanklist();
    // this.MembershipCredentials();
    this.getpaycode(); //扫码支付
    this.getUserMoney();
    this.orderGoodsInfo.forEach((item) => {
      this.midArr.push(item.bxmId);
      item.bxyCommodityList.forEach((goodsItem) => {
        this.cidArr.push(goodsItem.id);
      });
      this.account += Number(item.amount);
    });
    this.bankCentent();

    this.getkjtEnableList();
    //   this.searchRedEnvelope()
    // this.getshoworderList()
    // this.getcheckPay();
  },
  beforeDestroy() {
    //页面关闭时清除定时器
    clearInterval(this.clearTimeSet);
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 展开网银支付---
    changeCollapse(e) {
      // console.log(e, "e");
      if (e.length) {
        this.handleClick();
      }
    },
    handleClick(name) {
      this.bankaccounttype = this.activeName;
      bankList().then((res) => {
        if (res.code == 0) {
          if (this.activeName == 1) {
            let lists = res.rows.filter((item) => {
              return item.banktype == "储蓄卡";
            });
            if (lists[0].bankcodes.length <= 0) {
              this.navList = [];
            } else {
              this.navList = lists[0].bankcodes;
            }
            console.log("this.navList", " this.navList");
          } else if (this.activeName == 2) {
            let lists = res.rows.filter((item) => {
              return item.banktype == "信用卡";
            });
            if (lists[0].bankcodes.length <= 0) {
              this.navList = [];
            } else {
              this.navList = lists[0].bankcodes;
            }
          }
          console.log(this.navList, "navlist");
        }
      });
    },
    //添加会员凭证信息
    onhandleAdd() {
      this.$refs.rulesadd.validate((valid) => {
        if (valid) {
          voucheradd({
            uid: this.userInfo.userId,
            appid: this.ruleadd.appid,
            payaccount: this.ruleadd.payaccount,
          })
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    type: "success",
                    message: "添加成功!",
                  });
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                this.$message.error("添加失败");
              });
        } else {
          return false;
        }
      });
    },
    //判断是否需要上传会员凭证
    MembershipCredentials() {
      voucherlist({
        uid: this.userInfo.userId
      }).then((res) => {
        if (res.code == 0) {
          if (res.rows[0].appid !== "" && res.rows[0].payaccount !== "") {
            this.ruleadd.appid = res.rows[0].appid;
            this.ruleadd.payaccount = res.rows[0].payaccount;
            this.Membership = false;
            console.log(this.Membership, "this.Membership");
          }
        }
        // console.log(res.rows, "res");
      });
    },

    // handleClick(tab, event) {
    //   console.log(tab, event);
    // },
    changeCheck() {
      if (this.checked) {
        this.ruleForm.radio = "";
        this.fastChecked = false;
        this.paychecked = false;
      }
    },
    changePayCheck() {
      if (this.paychecked) {
        this.ruleForm.radio = "";
        this.fastChecked = false;
        this.checked = false;
      }
    },
    changeCheckRadio() {
      if (this.ruleForm.radio != "") {
        this.checked = false;
        this.fastChecked = false;
        this.paychecked = false;
      }
    },
    // 查询用户的有关金额
    getUserMoney() {
      getUserPay({
        userId: this.userInfo.userId,
      })
          .then((res) => {
            this.getUserPays = res.data;
          })
          .catch((err) => {
            this.$message.error("查询用户的有关金额失败，请稍后再试！");
          });
    },
    getSpecification(id) {
      let nameArr = [];
      getSpecificationselect({
        specificationId: id
      })
          .then((res) => {
            if (res.code == 0) {
              res.rows.forEach((item) => {
                nameArr.push(item.bXyAttributeList[0].name);
              });
              //   this.getaddresslist()
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.$message.error("删除失败，请稍后再试！");
          });
      return nameArr;
    },
    // 上传支付凭证
    handleAvatarIDSuccess(res, file) {
      console.log(res, URL.createObjectURL(file.raw));
      this.ruleForm.IDImg = res.url;
      // this.sizeForm.businessLicense =URL.createObjectURL(file.raw). substring(URL.createObjectURL(file.raw).lastIndexOf("/"));
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    orderNows() {
      console.log(this.ruleForm, "ruleform");

      const oidArr = []; // 订单id集合
      const outTradeNo = []; // 订单号集合
      this.orderGoodsInfo.forEach((item) => {
        oidArr.push(item.oid);
        outTradeNo.push(item.orderNumber);
      });
      if (this.ruleForm.radio == 1) {
        // 使用支付宝支付
        alipayPc({
          description: this.orderGoodsInfo[0].title,
          // 'goodsCode': this.orderGoodsInfo[0].oid, // 商品编号
          goodsTitle: this.orderGoodsInfo[0].title,
          // outTradeNo: this.orderGoodsInfo[0].orderNumber, // 订单号
          outTradeNo: outTradeNo.toString(), // 订单号
          //passbackParams: `${this.$baseUrl}/#/myOrderRight?orderNumer=${this.orderGoodsInfo[0].orderNumber}`,
          passbackParams: `https://www.gstianze.com/#/myOrderRight?orderNumer=${this.orderGoodsInfo[0].orderNumber}`,
          // passbackParams: `${this.$baseUrl}/custom/xunyou/xy_personvalue/api/deal`,
          storeId: this.orderGoodsInfo[0].bxmId, // 店铺id
          timeoutExpress: "30m",
          totalAmount: this.account,
        })
            .then((res) => {
              console.log("支付宝支付开始");
              const payDiv = document.getElementById("payDiv");
              if (payDiv) {
                document.body.removeChild(payDiv);
              }
              const div = document.createElement("div");
              div.id = "payDiv";
              div.innerHTML = res.msg;
              document.body.appendChild(div);
              document
                  .getElementById("payDiv")
                  .getElementsByTagName("form")[0]
                  .submit();
            }).catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("付款失败，请稍后再试！");
        });
      }
      if (this.ruleForm.radio == 2) {
        // 使用微信支付
        alipayPcWX({
          description: this.orderGoodsInfo[0].title,
          // outTradeNo: this.orderGoodsInfo[0].orderNumber,
          outTradeNo: outTradeNo.toString(),
          passbackParams: `${this.$baseUrl}/xunyou/myOrderRight?orderNumer=${this.orderGoodsInfo[0].orderNumber}`,
          totalAmount: this.account,
        })
            .then((res) => {
              this.$store.commit("getWxerweima", res.code_url);
              setTimeout(() => {
                //传参 order_number
                this.$router.push(
                    `/wxERweima?totalOrderNumber=${this.orderGoodsInfo[0].orderNumber}&outBizNo=${res.out_order_no}`
                );
              }, 800);
            })
            .catch((err) => {

              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("付款失败，请稍后再试！");
            });
      } else if (this.checked) {
        //使用余额支付
        balancePay({
          isHybridPay: 2, //   是否是混合支付 1:是 2：否
          uid: this.userInfo.userId, //用户ID
          type: 2, // 交易类型
          statusType: 2, // 出账
          note: this.orderGoodsInfo[0].title,
          amount: this.account,
          pay_psw: this.ruleForm.pass,
          // oid: this.orderGoodsInfo[0].oid, //oidArr
          oid: oidArr.toString(), //oidArr
          // 如果请求里面需要加字段,需要去(xunyou.js)里接口配一个
        })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("付款成功");
                this.$router.push(`/myOrderRight`);
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("付款失败，请稍后再试！");
              setTimeout(() => {
                this.$router.push("/paymentCenter");
              }, 800);
            });
      } else if (this.paychecked) {
        offlinePay({
          oid: oidArr.toString(),
          payforimg: this.ruleForm.IDImg,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功");
            setTimeout(() => {
              this.$router.push(`/myOrderRight`);
            }, 800);
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
          // }
          // } else {
          //   this.$message({
          //     type: "error",
          //     message: res.msg,
        });
      } else if (this.modeKey) {
        //使用网银支付
        if (!this.modeKey) {
          this.$message({
            type: "info",
            message: "请选择银行",
          });
          return;
        }
        const oidArr = []; // 订单id集合
        const outTradeNo = []; // 订单号集合
        this.orderGoodsInfo.forEach((item) => {
          oidArr.push(item.oid);
          outTradeNo.push(item.orderNumber);
        });
        getwy({
          terminal: "PC",
          outTradeNo: outTradeNo.toString(),
          uid: this.userInfo.userId,
          totalAmount: this.account,
          bankaccounttype: this.bankaccounttype,
          payaccount: this.ruleadd.payaccount,
          bankcode: this.bankCode,
          description: this.orderGoodsInfo[0].title,
        })
            .then((res) => {
              if (res.code == 0) {
                var formStr = res.data.data.htmldata;
                const payDiv = document.getElementById("payDiv");
                if (payDiv) {
                  document.body.removeChild(payDiv);
                }
                const div = document.createElement("div");
                div.id = "payDiv";
                div.innerHTML = formStr;
                document.body.appendChild(div);
                document
                    .getElementById("payDiv")
                    .getElementsByTagName("form")[0]
                    .submit();
              } else {
                this.$message(res.msg);
              }
            })
            .catch((err) => {
              this.$message(res.msg);
            });
      }
      // });
    },
    // 混合支付开启
    orderNowsmix() {
      // 获取余额支付比例
      getBalancePayProportion()
          .then((res) => {
            if (res.code == 0) {
              console.log(
                  Number(res.msg) / 100,
                  res.msg,
                  "查询余额支付比例失败，请稍后再试！"
              );
              this.balanceRatio = Number(res.msg) / 100;
              this.balanceRatioPrice = (Number(res.msg) / 100) * this.account;
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.$message.error("查询余额支付比例失败，请稍后再试！");
          });
      this.centerDialogVisible = true;
    },

    //混合支付
    mixPay() {
      // checkPay({
      //   orderNumber: this.orderGoodsInfo[0].orderNumber,
      //   value: this.orderGoodsInfo[0].orderAmount,
      // }).then((res) => {
      //   if (res.code == 0) {
      // 判断输入的金额是否大于最大支付余额
      if (this.balencePay > this.balanceRatioPrice) {
        this.$message.error(`支付金额不能超过${this.balanceRatioPrice}`);
      } else {
        //判断是否选择了第二种支付方式
        if (
            this.ruleForm.radio != 3 &&
            this.ruleForm.radio != 4 &&
            this.balencePay < this.account
        ) {
          this.$message.error("请选择与微信/支付宝组合支付方式");
          return;
        }
        const oidArr = []; // 订单id集合
        const outTradeNo = []; // 订单号集合
        this.orderGoodsInfo.forEach((item) => {
          oidArr.push(item.oid);
          outTradeNo.push(item.orderNumber);
        });

        //使用混合支付
        balancePayMax({
          isHybridPay: 1, //   是否是混合支付 1:是 2：否
          uid: this.userInfo.userId, //用户ID
          type: 2, // 交易类型
          statusType: 2, // 出账
          note: this.orderGoodsInfo[0].title,
          amount: this.balencePay,
          pay_psw: this.ruleForm.pass,
          oid: outTradeNo.toString(),
          // oid: this.orderGoodsInfo[0].oid,
          // 如果请求里面需要加字段,需要去(xunyou.js)里接口配一个
        })
            .then((res) => {
              if (res.code == 0) {
                //去支付宝混合
                if (this.ruleForm.radio == 3 && this.balencePay < this.account) {
                  alipayPc({
                    description: this.orderGoodsInfo[0].title,
                    goodsTitle: this.orderGoodsInfo[0].title,
                    outTradeNo: outTradeNo.toString(), // 订单号
                    passbackParams: `${this.$baseUrl}/custom/xunyou/xy_personvalue/api/dealMax`,
                    storeId: this.orderGoodsInfo[0].bxmId, // 店铺id
                    timeoutExpress: "30m",
                    totalAmount: Number(this.account) - Number(this.balencePay),
                  })
                      .then((res) => {
                        const payDiv = document.getElementById("payDiv");
                        if (payDiv) {
                          document.body.removeChild(payDiv);
                        }
                        const div = document.createElement("div");
                        div.id = "payDiv";
                        div.innerHTML = res;
                        document.body.appendChild(div);
                        document
                            .getElementById("payDiv")
                            .getElementsByTagName("form")[0]
                            .submit();
                      })
                      .catch((err) => {
                        this.editFormVisible = false;
                        this.loading = false;
                        this.$message.error("付款失败，请稍后再试！");
                        setTimeout(() => {
                          this.$router.push("/paymentCenter");
                        }, 800);
                      });
                }
                //微信混合
                else if (
                    this.ruleForm.radio == 4 &&
                    this.balencePay < this.account
                ) {
                  // 使用微信支付
                  alipayPcWX({
                    description: this.orderGoodsInfo[0].title,
                    outTradeNo: outTradeNo.toString(),
                    passbackParams: `${this.$baseUrl}/xunyou/myOrderRight?orderNumer=${this.orderGoodsInfo[0].orderNumber}`,
                    totalAmount: (
                        Number(this.account) - Number(this.balencePay)
                    ).toFixed(2),
                  })
                      .then((res) => {
                        this.$store.commit("getWxerweima", res.data.qrCodeUrl);
                        setTimeout(() => {
                          this.$router.push(
                              `/wxERweima?totalOrderNumber=${this.orderGoodsInfo[0].totalOrderNumber}&outBizNo=${res.data.out_order_no}`
                          );
                        }, 800);
                      })
                      .catch((err) => {
                        this.editFormVisible = false;
                        this.loading = false;
                        this.$message.error("付款失败，请稍后再试！");
                      });
                } else if (this.ruleForm.radio != 4 && this.ruleForm.radio != 3) {
                  balancePay({
                    isHybridPay: 1, //   是否是混合支付 1:是 2：否
                    uid: this.userInfo.userId, //用户ID
                    type: 2, // 交易类型
                    statusType: 2, // 出账
                    note: this.orderGoodsInfo[0].title,
                    amount: this.balencePay,
                    pay_psw: this.ruleForm.pass,
                    oid: oidArr.toString(),
                    // oid: this.orderGoodsInfo[0].oid,
                    // 如果请求里面需要加字段,需要去(xunyou.js)里接口配一个
                  })
                      .then((res) => {
                        if (res.code == 0) {
                          this.$message.success("付款成功！");
                        } else {
                          this.$message.error(res.msg);
                        }
                        this.loading = false;
                      })
                      .catch((err) => {
                        this.editFormVisible = false;
                        this.loading = false;
                        this.$message.error("付款失败，请稍后再试！");
                      });
                }
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("付款失败，请稍后再试！");
            });
      }
      // }else{
      //    this.$message({
      //     type: "error",
      //     message: res.msg,
      //   })
      // }
      // });
    },

    // ========================= 快捷通 支付 开始 ==========================================
    //获取银行编码
    getbanklist() {
      bankList().then((res) => {
        if (res.code == 0) {
          let lists = res.rows.filter((item) => {
            return item.banktype == "储蓄卡";
          });
          this.navList = lists[0].bankcodes;
        }
        //  console.log(res, "res");
      });
    },
    // 获取银行列表
    // getkjtbankList() {
    //   // kjtbankList().then((res) => {
    //   //   if (res.code == 0) {
    //   //     this.navLists = res.rows;
    //   //     // console.log(this.navList, "navlist");
    //   //   }
    //   // });
    // },

    // 获取快捷通 开关集合
    getkjtEnableList() {
      kjtEnable({
        mids: this.midArr,
        cIds: this.cidArr,
      }).then((res) => {
        if (res.code == 0) {
          this.kjtEnableObj = res.data;
          this.$store.commit("getkjtEnable", res.data);
        }
      });
    },

    // 快捷通
    changeFastCheck() {
      if (this.fastChecked) {
        this.openfastPay = "1";
        this.opencodePay = "";
        this.ruleForm.radio = "";
        this.checked = false;
        this.codeChecked = false;
      } else {
        this.openfastPay = "";
        this.opencodePay = "";
        this.codeChecked = false;
        this.ruleForm.radio = ""; // 关闭支付宝支付
        this.checked = true;
      }
    },
    // 二维码
    changecodeCheck() {
      if (this.codeChecked) {
        this.repayWX(); // 展开就调用二维码查询支付状态接口
        this.opencodePay = "1"; // 打开二维码折叠面板
        this.openfastPay = "";
        this.ruleForm.radio = ""; // 关闭支付宝支付
        this.checked = false; // 关闭余额
        this.fastChecked = false; // 关闭快捷通
      } else {
        clearInterval(this.clearTimeSet); //关闭清除定时器
        this.openfastPay = "";
        this.opencodePay = "";
        this.ruleForm.radio = ""; // 关闭支付宝支付
        this.fastChecked = false;
        this.checked = true;
      }
    },
    changeBack(item, index) {
      console.log(item, index);
      if (index > -1) {
        this.ruleForm.radio = "";
        this.checked = false;
      }
      this.bankCode = item.code;
    },
    bankCentent() {
      this.navList.map((item, index) => {
        this.bankLists.push(item.bankList);
      });
      //  console.log(this.bankLists,"this.bankLists");
    },
    // handleSelect(key, keyPath) {
    //   // this.bankCentent()
    //   // this.index = key;
    //   // if (key == 0) {
    //   //   this.payProductCode = 20;
    //   //   this.bankaccounttype=1
    //   // //  console.log(this.payProductCode);
    //   // console.log( this.bankaccounttype," this.bankaccounttype");
    //   // }
    //   // if (key == 1) {
    //   //   this.payProductCode = 31;
    //   //    this.bankaccounttype=0
    //   //     console.log( this.bankaccounttype," this.bankaccounttype");
    //   //  // console.log(this.payProductCode);
    //   // }
    //   // if (key == 3) {
    //   //   this.payProductCode = 40;
    //   //   console.log(this.payProductCode);
    //   // }
    // //  console.log(this.bankLists, "xxxx", this.index);
    // },

    wangYing() {
      if (!this.modeKey) {
        this.$message({
          type: "error",
          message: "请选择银行",
        });
        return;
      }
      const oidArr = []; // 订单id集合
      const outTradeNo = []; // 订单号集合
      this.orderGoodsInfo.forEach((item) => {
        oidArr.push(item.oid);
        outTradeNo.push(item.orderNumber);
      });
      getZtPay({
        outTradeNo: outTradeNo.toString(),
        muId: this.userInfo.userId,
        payProductCode: this.payProductCode,
        bankCode: this.bankCode,
      })
          .then((res) => {
            if (res.code == 0) {
              var formStr = res.msg;

              const payDiv = document.getElementById("payDiv");
              if (payDiv) {
                document.body.removeChild(payDiv);
              }
              const div = document.createElement("div");
              div.id = "payDiv";
              div.innerHTML = formStr;
              document.body.appendChild(div);
              document
                  .getElementById("payDiv")
                  .getElementsByTagName("form")[0]
                  .submit();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: res.msg,
            });
          });
    },

    // 二维码
    // 二维码支付回调参数
    repayWX() {
      this.clearTimeSet = setInterval(() => {
        paycodeStatus({
          orderNum: this.orderGoodsInfo[0].orderNumber,
        }).then((res) => {
          if (res.code == 0) {
            this.$router.push("/myOrderRight");
          }
        });
      }, 3000);
    },
    clearTime() {
      //清除定时器
      clearInterval(this.clearTimeSet);
    },
    getpaycode() {
      // checkPay({
      // orderNumber: this.orderGoodsInfo[0].orderNumber,
      // value: this.orderGoodsInfo[0].orderAmount,
      // }).then(res => {
      // if(res.code == 0){
      const oidArr = []; // 订单id集合
      const outTradeNo = []; // 订单号集合
      this.orderGoodsInfo.forEach((item) => {
        oidArr.push(item.oid);
        outTradeNo.push(item.orderNumber);
      });
      // 使用支付宝支付
      getZtAlipayPcPay({
        outTradeNo: outTradeNo.toString(),
        muId: this.userInfo.userId,
        source: "PC",
      }).then((res) => {
        console.log("使用支付宝");
        if (res.code == 0) {
          this.zfbAlipay = true;
          this.$nextTick(() => {
            document.getElementById("qrcode").innerHTML = "";
            new QRCode("qrcode", {
              width: 200,
              height: 200,
              text: res.msg,
            });
          });
        }
      });
      // }
      // })
    },
    // ========================= 快捷通 支付 结束 ==========================================

    //   getshoworderList(){
    //     showorderList({

    //     })
    //         .then(res => {
    //             console.log('查询订单',res)
    //           if (res.code == 0) {
    //             //   this.loading = false
    //             //   this.envelopeList = res.rows;
    //           } else {
    //             this.$message({
    //               type: 'info',
    //               message: res.msg
    //             })
    //           }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('查询红包失败，请稍后再试！')
    //         })
    //   }
    // orderNow(){
    //     this.$refs.ruleForm.validate((valid) => {
    //       if (valid) {
    //         // alert('submit!');
    //         alipay({
    //             outTradeNo:'pp',
    //             subject:'11',
    //             totalAmount:'1'
    //         })
    //         .then(res => {
    //             // this.payPage = res
    //         //   if (res.code == 0) {
    //         //       this.dialogVisible = true
    //         //   } else {
    //         //     this.$message({
    //         //       type: 'info',
    //         //       message: '付款失败，请稍后再试！'
    //         //     })
    //         //   }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('付款失败，请稍后再试！')
    //         })
    //       } else {
    //         console.log('error submit!!');
    //         return false;
    //       }
    //     });
    // }

    // // 红包查询
    //   searchRedEnvelope() {
    //       this.loading = true
    //      redEnvelope()
    //         .then(res => {
    //           if (res.code == 0) {
    //               this.loading = false
    //               this.envelopeList = res.rows;
    //           } else {
    //             this.$message({
    //               type: 'info',
    //               message: res.msg
    //             })
    //           }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('查询红包失败，请稍后再试！')
    //         })
    // },
  },
};
</script>

<style scoped lang="less">
// /deep/ .el-form-item {
//      margin-bottom: 0px;
// }
.orderSuccess /deep/ .el-collapse-item__header {
  font-size: 20px !important;
  font-weight: 600 !important;
}

.mixPayed {
  display: flex;
  justify-content: center;
  margin: 100px 0;
}

.currencyPayment {
  display: flex;

  width: 178px;
  border: 1px solid #eee;
  margin: 10px;
}

.currencyPayment_img {
  // margin-top: 10px;
  width: 50px;
  height: 50px;
  // overflow: hidden;

  background-position: center;
}

.currencyPayment:hover {
  border: 1px solid #409eff;
}

.currencyPayment_span {
  margin-right: 10px;
}

.orderSuccess {
  margin: 20px 0;
  background: white;
  padding: 30px 70px;
  font-size: 14px;

  .orderSuccess_icon {
    width: 80px;
    height: 80px;
    line-height: 80px;
    font-size: 40px;
    color: #83c44e;
    text-align: center;
    border: 2px solid #83c44e;
    border-radius: 42px;
  }

  .orderSuccess_tip {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #757575;

    .orderSuccess_text {
      margin-bottom: 10px;
      font-size: 24px;
      font-weight: 400;
    }

    .orderSuccess_price {
      font-size: 24px;
      color: #ff6700;
    }
  }

  .address_info {
    margin: 20px 0;
  }

  /deep/ .el-collapse {
    border-bottom: 0px !important;
  }

  /deep/ .el-collapse-item__header {
    font-size: 14px;
  }

  span.text_width {
    width: 10%;
    display: inline-block;
  }

  .text_bgcolor {
    display: inline-block;
    width: 80%;
    background: #f5f5f5;
  }

  .order_detail {
    display: inline-block;
    position: absolute;
    right: 30px;
  }

  .payMethods {
    font-size: 18px;

    .payMethods_title {
      margin: 20px 0;
      padding-bottom: 20px;
      border-bottom: 1px solid #ccc;
    }

    .checked_free {
      padding: 10px;
      color: #666;
      font-size: 14px;
      border: 1px solid #e7e7e7;
      margin: 20px 0;
    }

    .payMethods_img {
      // margin: 20px;
      border: 1px solid #ccc;
    }
  }

  button.el-button.buttonBgd.el-button--primary {
    background-color: #ff6700;
    border-color: #ff6700;
    font-size: 14px;
    margin: 20px 0;
  }

  .textCenter {
    text-align: center;
    font-size: 25px;
  }
}

.mixdialog {
  /deep/ .el-button.buttonBgd.el-button--primary {
    background-color: #ff6700 !important;
    border-color: #ff6700 !important;
  }
}

/deep/ .el-radio {
  color: #606266;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  margin-left: 10px;
}

.fastPay {
  /deep/ .buttonBgd {
    background-color: #ff6700;
    border-color: #ff6700;
    font-size: 14px;
    margin: 20px 0;
  }
}

.payParper {
  width: 20%;
  min-height: 150px;
  background: white;
  // text-align: center;
  border: 1px dashed #ccc;
  margin: 24px;
  display: inline-block;
  position: relative;

  .avatar {
    width: 100%;
    height: auto;
  }

  .uploadIcon {
    color: #ff6700;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shoppingcart/orderNow.vue